// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","612":"user-refunds","945":"dashboard"}[chunkId] || chunkId) + "-legacy." + {"76":"5d8f09b1","612":"3c668e26","789":"88ea0160","945":"1789d468"}[chunkId] + ".js";
};